




















































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import Coin from "@/models/porposal/coin.Model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import UserService from "../../../services/user.service";
import { PermissionValue } from "../../../enums/PermissionValue";
@Component
export default class CurrencyTableComponent extends GenericBTable<Coin> {
  created() {
    this.permissionValue = PermissionValue.MONEDA;
    this.tableConfig.controller = "Coins";
    this.tableConfig.actions.customTemplate = true;
  }

  mounted() {
    this.formatColumns();
  }

  formatColumns() {
    let currency = new BTableColumn("currency", "table.currency", true);
    this.tableConfig.insertColumns(currency);
    this.tableConfig.activeActions = this.permissionAccess.write;
    this.tableConfig.actions.customTemplate = this.permissionAccess.write;
  }
}
